import React, { useState, useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useParams, useHistory, Link } from "react-router-dom";

import "./tournament.css";
import { useSubheader } from "../../../_metronic/layout";

import { Multiselect } from "multiselect-react-dropdown";

import {
  Card,
  CardBody,
  CardHeader,
  DatePickerField,
  ModalProgressBar,
  Input,
  TimePickerField,
  CustomeSelect,
} from "../../../_metronic/_partials/controls";
// import * as UIHelpers from "./UIHelpers";

import {
  CONTEST_STATUS_BTN,
  // CONTEST_STATUS_BG,
  CONTEST_STATUS_BORDER,
} from "../../components/UIHelpers";
import { Formik, Form, Field, FieldArray } from "formik";

import { Col, Row } from "react-bootstrap";

// import { EndDatePickerField } from "../../../_metronic/_partials/controls/forms/EndDatePickerField";

const steps = [
  {
    title: "Rounds",
    code: "roundStep",
    icon: "flaticon-list",
  },
];

const AddTeam = (props) => {
  const suhbeader = useSubheader();
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [current, setCurrent] = useState(0);

  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);
  const [selectedDate, setSelectedDate] = React.useState(
    new Date("2014-08-18T21:11:54")
  );
  const [showInput, setShowInput] = useState(false);
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const [matches, setMatches] = useState([{}]);
  const [matches2, setMatches2] = useState([
    {
      rounds: "",
      multiselect: "",
      startDate: "",
      time: "",
      number1: "",
      number2: "",
    },
  ]);
  const [isAddRound, setIsAddRound] = useState(true);
  const handleAddMatch = () => {
    setMatches([
      ...matches,
      {
        rounds: "",
        multiselect: "",
        startDate: "",
        time: "",
        number1: "",
        number2: "",
      },
    ]);
  };
  const { id } = useParams();

  let history = useHistory();
  const onDateSet = (value, pData) => {
    if (pData && pData.type === "start") {
      setStartDate(value);
    }
    if (pData && pData.type === "end") {
      setEndDate(value);
    }
  };
  // const history = useHistory();
  const { currentState } = useSelector(
    (state) => ({ currentState: state.tournamentsSlice }),
    shallowEqual
  );
  const {
    actionsLoading,
    tournamentForEdit,

    someVariable,
    listLoading,
  } = currentState;
  const [count, setCount] = useState(1);
  const [count2, setCount2] = useState(1);
  useEffect(() => {
    setMatches(Array.from({ length: count }, () => ({})));
  }, [count]);

  const handleCountChange = (event) => {
    setCount(event.target.value);
  };

  useEffect(() => {
    setMatches2(Array.from({ length: count2 }, () => ({})));
  }, [count2]);

  const handleCountChange2 = (event) => {
    setCount2(event.target.value);
  };

  // Table pagination properties

  return (
    <Card>
      {<ModalProgressBar />}
      {/* {actionsLoading && <ModalProgressBar />} */}
      <CardHeader title={title}></CardHeader>
      <CardBody className="p-0">
        {/* <!--begin: Wizard--> */}
        <div className="wizard wizard-4">
          {/* <!--begin: Wizard Nav--> */}
          <div className="wizard-nav border-right">
            <div className="wizard-steps">
              {/* <!--begin::Wizard Step 1 Nav--> */}
              {steps.map((item, ind) => (
                // <Step key={item.title} title={item.title} />
                <div
                  style={{ width: `${parseFloat(100 / steps.length, 1)}%` }}
                  key={item.title}
                  className={
                    current === ind ? "current wizard-step" : "wizard-step"
                  }
                >
                  <div className="wizard-wrapper">
                    <div className="wizard-number">{ind + 1}</div>
                    <div className="wizard-label">
                      <div className="wizard-title">{item.title}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* <!--end: Wizard Nav--> */}
          {/* <!--begin: Wizard Body--> */}
          <div className="wizard-body px-8 py-8">
            <div className="row">
              <Formik>
                <Form className="form form-label-right w-100">
                  <div
                    className="pb-5"
                    data-wizard-type="step-content"
                    data-wizard-state="current"
                  >
                    <h4 className="mb-10 font-weight-bold text-dark">
                      Setup Your {steps[current].title}
                    </h4>
                    <div className="row"></div>
                    <div className="col-md-12 p-0">
                      <FieldArray>
                    
                        <Card className="gx-card clearfix">
                          <CardHeader title={`Round 1`}></CardHeader>
                          <CardBody>
                            {matches.map((match, index) => (
                              <Row key={index}>
                                
                                <Col lg={2} md={12} sm={24} xs={24}>
                                  <Field
                                    name={`rounds.name`}
                                    component={Input}
                                    placeholder={`Name`}
                                    required
                                  />
                                </Col>
                                <Col lg={2} md={12} sm={24} xs={24}>
                                  <Field
                                    name={`No. of matches`}
                                    component={Input}
                                    placeholder={`No. of matches`}
                                    onChange={handleCountChange}
                                    required
                                  />
                                </Col>
                               
                                 
                                    <Col lg={2} md={12} sm={24} xs={24}>
                                      <div>
                                        <input
                                          type="checkbox"
                                          id="checkbox-id"
                                          name="checkbox-name"
                                          style={{ width: "20px", height: "20px" }}
                                          onChange={() =>
                                            setShowInput(!showInput)
                                          }
                                        />
                                        <label htmlFor="checkbox-id">
                                          Does it have sub-matches?
                                        </label>
                                      </div>
                                    </Col>
                               

                                {showInput && (
                                  <Col lg={2} md={12} sm={24} xs={24}>
                                    <Field
                                      name="Count"
                                      component={Input}
                                      placeholder="Count"
                                      onChange={handleCountChange2}
                                      required
                                    />
                                  </Col>
                                )}

                                <Col lg={2} md={12} sm={24} xs={24}>
                                  <Field
                                    name="Player Count"
                                    component={Input}
                                    placeholder={`Player Count`}
                                    required
                                  />
                                </Col>
                                {!showInput && (
                                  <>
                                    <Col lg={2} md={12} sm={24} xs={24}>
                                      <Field
                                        name="Map"
                                        component={Input}
                                        placeholder={`Map`}
                                        required
                                      />
                                    </Col>
                                    <Col lg={2} md={12} sm={24} xs={24}>
                                      <Field
                                        name="Perspective"
                                        component={Input}
                                        placeholder={`Perspective`}
                                        required
                                      />
                                    </Col>
                                  </>
                                )}
                                
                               
                                <Col className="col-md-12">
                                  {" "}
                                  <h3>Contests Info</h3>
                                </Col>

                                <table className="table table-bordered w-100">
                                  <thead>
                                    <tr>
                                      <th scope="col">#</th>

                                      {/* <th width="150" scope="col">
                                        Contests
                                      </th> */}

                                      <th width="200" scope="col">
                                        Date
                                      </th>
                                      <th width="120" scope="col">
                                        Time Slot
                                      </th>
                                      <th scope="col">User Count</th>
                                      <th scope="col">Winner Count</th>
                                      <th scope="col">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {matches2.map((match, index) => (
                                      <tr>
                                        {" "}
                                        <td>
                                          <Field
                                            name="Rounds"
                                            readOnly={true}
                                            component={Input}
                                          />
                                        </td>
                                        {/* <td>
                                          <Multiselect></Multiselect>
                                        </td> */}
                                        <td>
                                          <DatePickerField
                                            name="startDate"
                                            date={selectedDate}
                                            onDateSet={handleDateChange}
                                          />
                                        </td>
                                        <td>
                                          <TimePickerField></TimePickerField>
                                        </td>
                                        <td>
                                          <Field
                                            name=""
                                            component={Input}
                                            type="number"

                                            // onChange={values.rounds[rind] ? values.rounds[rind].isSaved : false}
                                          />
                                        </td>
                                        <td>
                                          <Field
                                            name=""
                                            component={Input}
                                            type="number"
                                          />
                                        </td>
                                        <td>
                                          <button
                                            type="button"
                                            className="btn btn-danger"
                                            title="Remove Match"
                                          >
                                            <span className="flaticon2-trash"></span>
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>

                                  {/* <td colSpan="7" className="text-center">
                                    <button
                                      type="button"
                                      className="btn btn-success"
                                      onClick={handleAddMatch}
                                    >
                                      Add Match
                                    </button>
                                  </td> */}
                                </table>
                              </Row>
                            ))}
                          </CardBody>
                          <div className="col-12">
                            {isAddRound && (
                              <div className="col-md-12">
                                <button
                                  type="button"
                                  className="btn btn-success"
                                  title="Add Round"
                                  // onClick={() => {
                                  //   arrayHelpers.push({});
                                  //   setIsAddRound(true);
                                  // }}
                                >
                                  Add Round
                                </button>
                              </div>
                            )}
                          </div>
                        </Card>
                        
                      </FieldArray>
                    </div>
                  </div>
                </Form>
              </Formik>
            </div>
          </div>
          {/* <!--end: Wizard Body--> */}
        </div>
      </CardBody>
    </Card>
  );
};
export default AddTeam;
